import Ajax from '../ajax';

export default {
  refund: (id) => Ajax('put', `payment/refund/${id}`),
};
